import * as React from 'react'

// Components
import Svg from './..'

const Chart = props => {
  return (
    <Svg fill='none' viewBox='0 0 12 11' {...props}>
      <path
        clipRule='evenodd'
        d='M8.119 5.796L5.196 3.919l-4.182 6.63c-.107.166-.238.249-.392.249-.154 0-.285-.036-.392-.107s-.178-.178-.214-.32-.012-.274.071-.405l4.491-7.045a.56.56 0 01.345-.25.52.52 0 01.416.071l2.946 1.89 2.71-3.91a.51.51 0 01.344-.213.51.51 0 01.606.428.51.51 0 01-.083.392L8.856 5.665c-.084.119-.202.19-.345.214s-.273 0-.392-.083zm.285 3.184l2.673-2.4-.012-.024a.51.51 0 01.393-.13.602.602 0 01.392.178.51.51 0 01.13.392.522.522 0 01-.178.368l-3.006 2.71c-.107.094-.226.142-.356.142s-.25-.036-.345-.107L4.685 7.47l-.653-.166.618-.963.416.107c.07.024.142.048.202.095zM1.228 6.64l-.82-.203.012-.011a.537.537 0 01-.333-.25c-.083-.13-.107-.261-.071-.404s.119-.25.25-.32.273-.096.415-.06l1.165.285z'
        fill='#ff9545'
        fillRule='evenodd'
      />
    </Svg>
  )
}

export default Chart
